import moment from 'moment-timezone';
import { convertToAppointment } from '../../appointments/action/AppointmentsConverter';
import { convertToDeposit } from '../../invoices/InvoicesConverter';
export var convertToBooking = function (bookingDto, masterData, timeZone) {
    return {
        id: bookingDto.id,
        uuid: bookingDto.uuid,
        bookedAt: moment(bookingDto.booked_at).tz(timeZone),
        customer: {
            id: bookingDto.customer_id,
            firstName: bookingDto.customer_first_name,
            lastName: bookingDto.customer_last_name,
            phone: bookingDto.customer_phone,
            email: bookingDto.customer_email,
            blocked: bookingDto.customer_blocked,
            address: bookingDto.customer_address,
            deleted: bookingDto.customer_deleted
        },
        appointments: bookingDto.appointments.map(function (appDto) { return convertToAppointment(appDto, masterData, timeZone, bookingDto.customer_deleted); }),
        invoiceIds: bookingDto.invoices,
        destroyable: bookingDto.destroyable,
        deposits: (bookingDto.deposits || []).map(function (depositDto) { return convertToDeposit(depositDto); }),
        createdAt: moment(bookingDto.created_at),
        updatedAt: moment(bookingDto.updated_at)
    };
};
export var convertToLock = function (dto, bookingId) { return ({
    status: dto.result === 'ok' ? 'locked' : 'rejected',
    bookingId: bookingId,
    lockedBy: {
        userId: dto.user.id,
        firstName: dto.user.first_name,
        lastName: dto.user.last_name,
        avatar: dto.user.image,
        staffId: dto.user.staff_id,
    },
}); };
